import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {TextListObject} from '@PosterWhiteboard/items/text-item/text-list';

export function useGetKeyFromListOfActiveSlideItem<T extends keyof TextListObject>(key: T): TextListObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      const slideItem = itemCopy.slides.slidesHashMap[itemCopy.selectedSlideUID];

      if (slideItem && 'list' in slideItem && slideItem.list[key] !== undefined) {
        return slideItem.list[key];
      }
    }

    return undefined;
  });
}
